export default __webpack_public_path__ + "static/media/icon-energy-logo.859cd019.png";